import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["role", "tabindex", "onKeydown"]
const _hoisted_2 = { class: "ui-tag__label" }

import { computed } from 'vue';

type TagTone = 'neutral' | 'primary' | 'success' | 'danger';
type TagSize = 'sm' | 'md';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tag',
  props: {
    label: { default: '' },
    tone: { default: 'neutral' },
    size: { default: 'md' },
    clickable: { type: Boolean, default: false },
    removable: { type: Boolean, default: false }
  },
  emits: ["click", "remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const tagClasses = computed(() => [
  'ui-tag',
  `ui-tag--${props.tone}`,
  `ui-tag--${props.size}`,
  {
    'is-clickable': props.clickable,
    'is-removable': props.removable
  }
]);

function handleClick(): void {
  if (!props.clickable) {
    return;
  }

  emit('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(tagClasses.value),
    role: __props.clickable ? 'button' : undefined,
    tabindex: __props.clickable ? 0 : undefined,
    onClick: handleClick,
    onKeydown: [
      _withKeys(_withModifiers(handleClick, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers(handleClick, ["prevent"]), ["space"])
    ]
  }, [
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(__props.label), 1 /* TEXT */)
      ])
    ]),
    (__props.removable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "ui-tag__remove",
          "aria-label": "Remove tag",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('remove')), ["stop"]))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "material-icons" }, "close", -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true)
  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})